
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g5k0ZK4lLt7U6xiQ583D7uFP95KAg9Z_J27_ndJ242uQMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexriVXPXm6Oe_45bvE_mZ8byz4Rdm3uCnSjZcIeyVRtsh_0Meta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchU6pEsmeof5QRIWFvn9yswZVoHsoj_45QXAg_GRLqZjeWgMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexMuCkrsQl6CqAou1WCQC1zSrMOIaVfR9dPaOjhdcAwPgMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93pe9cN7AfnZJWpGCilVv1O_zkg9diVmRwuodszY0BllQMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexGvgfDGO51FbA_45ZdfvMsAaWK7fpBeimNmuXl85Q_s2_oMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93XW7z9Cy5W8CYdRZ2n32PkXNCKi2FmfMHcnzN0TlHJx8Meta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexLG_45HQFTXOolSTDCfnI7c7__w_45MIpoG7wNSzW08s0NjAMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93s1HI8OpPdnFtmf3nenZzrudkaH6eVFjK7WKV1_45zqeesMeta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexc_4505EWnmtcbCHulAksp38p7MO30Ut1Joky_PtfXvqA0Meta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexMzQiZFMS0IfJob6ZeG2aLaQxd4DiOljvxk05jmBsqp0Meta } from "/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexGvgfDGO51FbA_45ZdfvMsAaWK7fpBeimNmuXl85Q_s2_oMeta || {},
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexLG_45HQFTXOolSTDCfnI7c7__w_45MIpoG7wNSzW08s0NjAMeta || {},
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexc_4505EWnmtcbCHulAksp38p7MO30Ut1Joky_PtfXvqA0Meta || {},
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexMzQiZFMS0IfJob6ZeG2aLaQxd4DiOljvxk05jmBsqp0Meta || {},
    component: () => import("/codebuild/output/src3069971282/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]